import React, { useEffect, useState } from 'react';
import Fireworks from 'react-canvas-confetti/dist/presets/fireworks';
import { useMetadata } from '../../context/MetadataContext';
import FormattedTime from '../../utils/FormattedTime';
import CountryFlag from '../../utils/CountryFlag';
import { getValue } from '../../utils/getValue';
import styles from './MirrorResults.module.css';
import { useGameState } from '../../context/GameStateContext';
import { useGlobalError } from '../../context/GlobalErrorContext';
import { useUser } from '../../context/UserContext';
import {
  Home,          // Close/Home
  Search         // Find another
} from 'lucide-react';



const MirrorResults = () => {
  const { getText } = useMetadata();
  const { gameData, rejectPuzzle, findPuzzle } = useGameState();
  const { userData } = useUser();

  // Determine if the player won or lost based on the duel_outcome from the API
  const playerWon = getValue(gameData, 'stats.player_won');
  const [showFireworks, setShowFireworks] = useState(false);
  console.log('gameData: ', gameData)

  // Fire fireworks when player wins
  useEffect(() => {
    if (playerWon) {
      // Small delay to let the component render
      const timer = setTimeout(() => {
        setShowFireworks(true);

        // Hide fireworks after duration
        setTimeout(() => {
          setShowFireworks(false);
        }, 2000);
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [playerWon]);

  const onCloseResults = () => {
    rejectPuzzle();
  };

  const onFindAgain = () => {
    findPuzzle();
  }

  return (
    <div className="dataContainer">
      {showFireworks && (
        <Fireworks autorun={{ speed: 1, duration: 2000 }} />
      )}
      <div className="containerHeader">
        <h2>{getValue(gameData,'messages.post_play')}</h2>
      </div>

      <div className="dataContent">
        {/* Player */}
        <div className="contentGroup">
          <div className="groupHeader">
            <h3>{userData?.nickname} ({getText('common_text.you')}) <CountryFlag countryCode={userData.countryCode} /> </h3>
          </div>

          <div className="dataRow">
            <span className="dataLabel">{getText('common_text.total_time')}:</span>
            <span className="dataValue"><FormattedTime seconds={getValue(gameData, 'state.total_time')} /></span>
          </div>

          <div className="subDataRow">
            <span className="subDataLabel">{getText('common_text.clock_time')}:</span>
            <span className="subDataValue"><FormattedTime seconds={getValue(gameData, 'state.clock_time')} /></span>
          </div>

          <div className="subDataRow">
            <span className="subDataLabel">
              {getText('common_text.penalty_time')} ({getText('common_text.hints').toLowerCase()} {getValue(gameData,'state.hint_count')}):
           </span>
            <span className="subDataValue">
              <FormattedTime seconds={getValue(gameData, 'state.penalty_time')} />
            </span>
          </div>

          <div className="dataRow">
            <span className="dataLabel">{getText('common_text.difference')}:</span>
            <span className="dataValue">{getValue(gameData, 'stats.time_percent_different')}% {playerWon ? getText('common_text.faster') : getText('common_text.slower')}</span>
          </div>

          <div className="dataRow">
            <span className="dataLabel">{getText('common_text.moves')}:</span>
            <span className="dataValue">{getValue(gameData, 'state.move_count')}</span>
          </div>

        </div>

        {/* Previous Performance */}
        <div className="contentGroup">
          <div className="groupHeader">
            <h3>{getText('mirror_mode.previous_performance')}</h3>
          </div>

          <div className="dataRow">
            <span className="dataLabel">{getText('common_text.total_time')}:</span>
            <span className="dataValue"><FormattedTime seconds={getValue(gameData, 'stats.previous_total_time')} /></span>
          </div>

          <div className="dataRow">
            <span className="dataLabel">{getText('common_text.moves')}:</span>
            <span className="dataValue">{getValue(gameData, 'stats.previous_move_count')}</span>
          </div>

          <div className="dataRow">
            <span className="dataLabel">{getText('common_text.hints')}:</span>
            <span className="dataValue">{getValue(gameData, 'stats.previous_hint_count')}</span>
          </div>
        </div>

      </div>

      <div className="actionButtonContainer">
        <button
          className="iconButton secondaryButton"
          onClick={onCloseResults}
          title={getText('common_text.close')}
          aria-label={getText('common_text.close')}
        >
          <Home className="buttonIcon" />
        </button>
        <button
          className="iconButton primaryButton"
          onClick={onFindAgain}
          title={getText('common_text.find_another')}
          aria-label={getText('common_text.find_another')}
        >
          <Search className="buttonIcon" />
        </button>
      </div>
    </div>
  );
};

export default MirrorResults;
